export enum ClientType {
  Client = 1,
  Product = 2,
  Wood = 3,
  Partner = 4,
  Baby = 5,
  Corporate = 6,
  Adviser = 7,
}
